import React from "react";
import { FaSquareFacebook, FaSquareTwitter } from "react-icons/fa6";

const pageUrl = typeof window !== "undefined" ? window.location.href : "";

const socialLinks = [
  {
    icon: <FaSquareFacebook size={21} />,
    text: "Facebook",
    className: "text-blue-600",
    url: `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`,
  },
  {
    icon: <FaSquareTwitter size={21} />,
    text: "Twitter",
    className: "text-sky-500",
    url: `https://twitter.com/intent/tweet?url=${pageUrl}`,
  },
  ,
];

const openSharePopup = url => {
  const width = 600;
  const height = 400;
  const left = (screen.width - width) / 2;
  const top = (screen.height - height) / 2;

  window.open(
    url,
    "_blank",
    `width=${width},height=${height},top=${top},left=${left}`
  );
};

const SociaShare = () => {
  return (
    <div className="absolute flex flex-col justify-start items-start top-full left-1/2 mt-3 flex -translate-x-1/2 items-center gap-4 border border-gray-200 bg-white px-4 py-3 shadow-xl">
      {socialLinks.map((item, index) => (
        <div
          key={index}
          onClick={() => openSharePopup(item?.url)}
          className={`text-2xl flex ${item.className} cursor-pointer`}
        >
          {item.icon}
          <span className="mx-2 font-light text-sm text-[#232323]">
            {item.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SociaShare;
